// check if is A-M site

var is_site_am = false
var domain = window.location.hostname
if( !domain || !domain.length ) alert('ERROR #56 - domain name could not be determined')
if( domain ==       'a-management.eu' ) is_site_am = true
if( domain ==   'www.a-management.eu' ) is_site_am = true
if( domain ==     'a-management.test' ) is_site_am = true
if( domain == 'www.a-management.test' ) is_site_am = true

if( window.location.hostname == 'localhost' || window.location.hostname == '127.0.0.1' ) {
    //is_site_am = true // debug/dev
}

window.is_site_am = is_site_am

// analytics id
window.gauaid = 'UA-142412636-1'
if( is_site_am ) window.gauaid = 'UA-142412636-2'

export default is_site_am



// WEBPACK FOOTER //
// ./src/is_site.js